const wrapButton = (visible, attributes, color) => `
<div
    class="carousel__controls ${!visible ? "invisible" : ""}"
    >
  <button ${attributes} data-color="${color}">
    <?xml version="1.0" encoding="UTF-8"?>
    <svg width="21px" height="35px" viewBox="0 0 21 35">
        <g id="Icons" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Icons-–-Web---no-bounding-boxes" transform="translate(-775.000000, -2103.000000)">
                <g id="general" transform="translate(132.000000, 431.000000)">
                    <g id="outlined-alternatives-" transform="translate(0.000000, 1524.000000)">
                        <g id="column_3" transform="translate(632.000000, 100.000000)">
                            <g id="Group" transform="translate(0.000000, 44.000000)">
                                <g id="web/icons/general/chevron-large" transform="translate(11.585734, 4.585786)">
                                    <polygon fill="#FFFFFF" fill-rule="nonzero" transform="translate(10.193251, 16.970702) rotate(-360.000000) translate(-10.193251, -16.970702) " points="20.386502 16.9712363 3.41526573 -6.36646291e-12 2.60833573e-05 3.41523964 13.5552657 16.9702136 0 30.5261614 3.415243 33.9414044"></polygon>
                                    <polygon fill="${color}" transform="translate(10.193236, 16.970691) rotate(-360.000000) translate(-10.193236, -16.970691) " points="3.41523629 1.41419084 1.41423629 3.41519084 14.9712363 16.9711908 1.41423629 30.5261908 3.41523629 32.5271908 18.9722363 16.9711908"></polygon>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
  </button>
</div>
`;

const renderButton = (type, attributes, color) =>
  wrapButton(type === "carousel", attributes, color);

export const nextCarouselButton = (type, color = "black") =>
  renderButton(type, `class="next-page js-next" aria-label="next"`, color);

export const previousCarouselButton = (type, color = "black") =>
  renderButton(
    type,
    `class="previous-page js-previous" aria-label="previous"`,
    color
  );
